export class APIError extends Error {
  constructor(
    public status: number,
    public code: string,
    message: string,
    public details?: any
  ) {
    super(message);
    this.name = 'APIError';
  }

  static fromResponse(response: any): APIError {
    const status = response.status || 0;
    const data = response.data || {};

    return new APIError(
      status,
      data.code || 'API_ERROR',
      data.message || 'An API error occurred',
      data.details
    );
  }

  static networkError(message: string = 'Network error occurred'): APIError {
    return new APIError(0, 'NETWORK_ERROR', message);
  }

  static timeoutError(message: string = 'Request timeout'): APIError {
    return new APIError(0, 'TIMEOUT_ERROR', message);
  }

  static unknownError(message: string = 'Unknown error occurred'): APIError {
    return new APIError(0, 'UNKNOWN_ERROR', message);
  }

  get isNetworkError(): boolean {
    return this.code === 'NETWORK_ERROR';
  }

  get isTimeoutError(): boolean {
    return this.code === 'TIMEOUT_ERROR';
  }

  get isAuthError(): boolean {
    return this.status === 401 || this.code === 'AUTH_ERROR';
  }

  get isForbiddenError(): boolean {
    return this.status === 403;
  }

  get isValidationError(): boolean {
    return this.status === 422 || this.code === 'VALIDATION_ERROR';
  }

  get isServerError(): boolean {
    return this.status >= 500;
  }

  toJSON() {
    return {
      name: this.name,
      message: this.message,
      status: this.status,
      code: this.code,
      details: this.details,
    };
  }
}
